module.exports = __webpack_public_path__ + "img/footer-88ab12.png";